import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';

export interface OkDialogData extends MatDialogConfig {
    title: string;
    description?: string; // can get rid of this
    multiDescriptions?: string[];
    boldMessage?: string;
    hint?: string;
    warningIcon?: string;
    close_button_text?: string;
    close_button_class?: string;
    confirm_button_text?: string;
    confirm_button_class?: string;
}

export const confirmationDialogHelper = {
    blockAccountsAccess: (count: number) => ({
        title: 'Block account access',

        multiDescriptions: [
            `You are about to block <span class="font-bold">  ${count === 1 ? '1 account' : `${count} accounts`} </span>  from accessing Microsoft 365 services.`,
            'They will be signed out immediately and will be unable to log back in until unblocked.',
        ],
        hint: 'This action takes effect right away and may disrupt active sessions.',
        confirm_button_text: 'Block',
        confirm_button_class: 'danger',
        warningIcon: 'error_outline',
    }),
};

@Component({
    selector: 'app-ok-dialog',
    templateUrl: './ok-dialog.component.html',
    styleUrls: ['./ok-dialog.component.scss'],
})
export class OkDialogComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<OkDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: OkDialogData,
    ) {
        console.log('data', data);
    }

    ngOnInit() {}

    closeClick(): void {
        this.dialogRef.close();
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }

    onConfirm(): void {
        this.dialogRef.close(true);
    }
}
